(function () {
  "use strict";

  /* ---------- mobile drawer ---------- */
  var toggle = document.getElementById("menuToggle");
  var drawer = document.getElementById("mobile-nav");
  if (toggle && drawer) {
    function closeDrawer() { drawer.classList.remove("open"); toggle.setAttribute("aria-expanded", "false"); }
    function openDrawer() { drawer.classList.add("open"); toggle.setAttribute("aria-expanded", "true"); }
    toggle.addEventListener("click", function () {
      drawer.classList.contains("open") ? closeDrawer() : openDrawer();
    });
    drawer.querySelectorAll("[data-close]").forEach(function (el) {
      el.addEventListener("click", closeDrawer);
    });
  }

  /* ---------- mobile tab bar: active state ---------- */
  var tabbar = document.querySelector("[data-tabbar]");
  if (tabbar) {
    var tabs = Array.prototype.slice.call(tabbar.querySelectorAll("a"));
    var here = window.location.pathname.replace(/\/$/, "") || "/";

    function markActiveByPath() {
      tabs.forEach(function (t) {
        try {
          var url = new URL(t.getAttribute("href"), window.location.origin);
          var tabPath = url.pathname.replace(/\/$/, "") || "/";
          var matches = tabPath === here && (url.hash === "" || url.hash === window.location.hash);
          t.classList.toggle("active", matches);
        } catch (e) { /* ignore malformed hrefs */ }
      });
    }
    markActiveByPath();

    // On the homepage, also spy on scroll position for hash-only tabs (#shop, #contact, etc.)
    if (here === "/") {
      var hashTabs = tabs.filter(function (t) {
        var href = t.getAttribute("href") || "";
        return href.indexOf("#") !== -1;
      });
      var targets = hashTabs
        .map(function (t) {
          var hash = (t.getAttribute("href").split("#")[1] || "");
          var el = hash ? document.getElementById(hash) : document.getElementById("top");
          return el ? { tab: t, el: el } : null;
        })
        .filter(Boolean);

      if (targets.length) {
        var onScroll = function () {
          var y = window.scrollY + 130;
          var current = targets[0];
          targets.forEach(function (pair) {
            if (pair.el.offsetTop <= y) current = pair;
          });
          tabs.forEach(function (t) { t.classList.remove("active"); });
          current.tab.classList.add("active");
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
      }
    }
  }

  /* ---------- FAQ: only one open at a time (optional nicety) ---------- */
  document.querySelectorAll(".faq-list details").forEach(function (item) {
    item.addEventListener("toggle", function () {
      if (item.open) {
        document.querySelectorAll(".faq-list details").forEach(function (other) {
          if (other !== item) other.open = false;
        });
      }
    });
  });

  /* ---------- cart toast ---------- */
  var toast = document.createElement("div");
  toast.className = "cart-toast";
  toast.setAttribute("role", "status");
  toast.setAttribute("aria-live", "polite");
  document.body.appendChild(toast);
  var toastTimer;
  function showToast(message) {
    toast.textContent = message;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 2200);
  }

  /* ---------- add to cart (Shopify AJAX Cart API) ---------- */
  function updateCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var dot = document.getElementById("cartDot");
        if (dot) dot.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-add-to-cart]");
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    btn.disabled = true;
    var originalHTML = btn.innerHTML;

    var qty = 1;
    var buyBox = btn.closest("[data-buy-box]");
    if (buyBox) {
      var qtyInput = buyBox.querySelector("#ProductQty");
      if (qtyInput) {
        var parsedQty = parseInt(qtyInput.value, 10);
        if (parsedQty > 0) qty = parsedQty;
      }
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        btn.classList.add("added");
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l4 4 10-10"/></svg>';
        showToast("Added to your bag");
        updateCartCount();
        setTimeout(function () {
          btn.classList.remove("added");
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }, 1400);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
        showToast((err && err.description) || "Couldn't add that item — try again.");
      });
  });

  /* ---------- hero node-network canvas ---------- */
  var canvas = document.getElementById("nodeCanvas");
  if (canvas && canvas.getContext) {
    var ctx = canvas.getContext("2d");
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var W, H, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var nodes = [];
    var NODE_COUNT;

    function hexToRgb(hex) {
      hex = (hex || "").trim().replace("#", "");
      if (hex.length === 3) hex = hex.split("").map(function (c) { return c + c; }).join("");
      var num = parseInt(hex, 16);
      if (isNaN(num)) return { r: 45, g: 208, b: 201 };
      return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
    }

    var cs = getComputedStyle(document.documentElement);
    var nodeColor = hexToRgb(cs.getPropertyValue("--teal-bright") || "#2dd0c9");
    var lineColorA = hexToRgb(cs.getPropertyValue("--teal-bright") || "#2dd0c9");
    var lineColorB = hexToRgb(cs.getPropertyValue("--coral-soft") || "#ff8a70");

    function sizeCanvas() {
      var hero = canvas.closest(".hero");
      W = hero.offsetWidth; H = hero.offsetHeight;
      canvas.width = W * dpr; canvas.height = H * dpr;
      canvas.style.width = W + "px"; canvas.style.height = H + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      NODE_COUNT = W < 640 ? 22 : 40;
      nodes = [];
      for (var i = 0; i < NODE_COUNT; i++) {
        nodes.push({
          x: Math.random() * W, y: Math.random() * H,
          vx: (Math.random() - 0.5) * 0.18, vy: (Math.random() - 0.5) * 0.18,
          r: Math.random() * 1.6 + 1.1
        });
      }
    }

    function frame() {
      ctx.clearRect(0, 0, W, H);
      var maxDist = W < 640 ? 110 : 150;
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (!reduceMotion) {
          n.x += n.vx; n.y += n.vy;
          if (n.x < 0 || n.x > W) n.vx *= -1;
          if (n.y < 0 || n.y > H) n.vy *= -1;
        }
      }
      for (var a = 0; a < nodes.length; a++) {
        for (var b = a + 1; b < nodes.length; b++) {
          var dx = nodes[a].x - nodes[b].x, dy = nodes[a].y - nodes[b].y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < maxDist) {
            var alpha = (1 - dist / maxDist) * 0.22;
            var grad = ctx.createLinearGradient(nodes[a].x, nodes[a].y, nodes[b].x, nodes[b].y);
            grad.addColorStop(0, "rgba(" + lineColorA.r + "," + lineColorA.g + "," + lineColorA.b + "," + alpha + ")");
            grad.addColorStop(1, "rgba(" + lineColorB.r + "," + lineColorB.g + "," + lineColorB.b + "," + alpha + ")");
            ctx.strokeStyle = grad;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(nodes[a].x, nodes[a].y);
            ctx.lineTo(nodes[b].x, nodes[b].y);
            ctx.stroke();
          }
        }
      }
      nodes.forEach(function (n) {
        ctx.beginPath();
        ctx.arc(n.x, n.y, n.r, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(" + nodeColor.r + "," + nodeColor.g + "," + nodeColor.b + ",0.85)";
        ctx.fill();
      });
      if (!reduceMotion) requestAnimationFrame(frame);
    }

    sizeCanvas();
    frame();
    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { sizeCanvas(); if (reduceMotion) frame(); }, 200);
    });
  }
})();
